import { Component, OnInit } from '@angular/core';
import { DataService } from '../shared/services/data-service/data.service';
import { StoreService } from '../shared/services/store-service/store.service';

@Component({
  standalone: false,
  selector: 'app-supplier-profile',
  templateUrl: './supplier-profile.component.html',
  styleUrls: ['./supplier-profile.component.scss'],
})
export class SupplierProfileComponent implements OnInit {
  loading: boolean;
  searchString: string = '';

  constructor(
    private dataService: DataService,
    public storeService: StoreService
  ) {
    this.loading = true;
  }

  async ngOnInit(): Promise<void> {
    await this.dataService.initSupplierProfiles();
    this.loading = false;
  }

  clearSearch() {
    this.searchString = '';
  }
}

